import { SetScrollButtonStatusType, SET_SCROLL_BUTTON_STATUS, SET_SIDE_SCROLL, SetSideScrollType, RESET_SCROLL_DATA, ResetScrollDataType } from '../actions/forecastPageScrollActions';
import { ScrollButtonStatus, SideScrollType } from '../../components/forecasts/common/types';

export type ForecastScrollStateType = {
    scrollButtonStatus: ScrollButtonStatus;
    sideScroll: SideScrollType;
}
const initialState: ForecastScrollStateType = {
    scrollButtonStatus: {
        isLeftScrollButtonDisabled: false,
        isRightScrollButtonDisabled: false
    },
    sideScroll: {
        isMouseBtnDown: false,
        left: 0,
        top: 0,
        x: 0,
        y: 0
    }
};

type ForecastPageActionTypes = SetScrollButtonStatusType | SetSideScrollType | ResetScrollDataType;

export function forecastPageScroll(state = initialState, action: ForecastPageActionTypes): ForecastScrollStateType
{
    switch (action.type)
    {
        case SET_SCROLL_BUTTON_STATUS:
        {
            return {
                ...state,
                scrollButtonStatus: action.payload
            };
        }
        case SET_SIDE_SCROLL:
        {
            return {
                ...state,
                sideScroll: action.payload
            };
        }
        case RESET_SCROLL_DATA: 
        {
            return {
                ...state,
                ...initialState
            };
        }
        default: 
        {
            return state;
        }
    }
}